export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    displayName: '',
    supperAdmin: false,
    userinfo: {
    },
    orgInfo:{},
    orgId:'',
    entId:'',
    selectInternalRoleId:'',
    internalRoleIds:[],
    state:'',
  },
  mutations: {
    updateId (state, id) {
      state.id = id
    },
    updateUser (state, userinfo) {
      state.userinfo = userinfo
    },
    updateName (state, name) {
      state.name = name
    },
    updateDisplayName (state, name) {
      state.displayName = name
    },
    updateSupperAdmin (state, name) {
      state.supperAdmin = name
    },
    updateOrgInfo (state, orgInfo) {
      state.orgInfo = orgInfo
    },
    updateOrgId (state, orgId) {
      state.orgId = orgId
    },
    updateEntId (state, entId) {
      state.entId = entId
    },
    updateSelectInternalRoleId (state, selectInternalRoleId) {
      state.selectInternalRoleId = selectInternalRoleId
    },
    updateInternalRoleIds (state, internalRoleIds) {
      state.internalRoleIds = internalRoleIds
    },
    getStatus (data, state) {
      data.state = state
    },
  }
}
